<template>
  <div class="Exporthk4">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk4(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk4") }}
        </v-btn> -->
            <download-excel
              :data = "papardatahk4"
              type="csv"
              name="hk4.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk4") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk4"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk4",
  setup() {},
  props: [
    "papardatahk4",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "Pusingan"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      { text: "NOAIR", value: "NOAIR"},
      // { text: "KAW", value: "KAW"},
      // { text: "Bulan", value: "Bulan"},
      // { text: "Tahun", value: "Tahun"},
      // { text: "BPK", value: "BPK"},
      // { text: "IDBPK", value: "IDBPK"},
      { text: "HK4PK", value: "HK4PK"},
      { text: "HK4PN", value: "HK4PN"},
      { text: "HK4M", value: "HK4M"},
      { text: "HK4S38", value: "HK4S38"},
      { text: "HK4S39", value: "HK4S39"},
      { text: "HK4b1", value: "HK4b1"},
      { text: "HK4b2", value: "HK4b2"},
      { text: "HK4a1", value: "HK4a1"},
      { text: "HK4a2", value: "HK4a2"},
      { text: "HK4a3", value: "HK4a3"},
      { text: "HK4a4", value: "HK4a4"},
      { text: "HK4C1", value: "HK4C1"},
      { text: "HK4C2", value: "HK4C2"},
      { text: "HK4C3", value: "HK4C3"},
      { text: "HK4C4", value: "HK4C4"},
      { text: "HK4INCS21b", value: "HK4INCS21b"},
      { text: "HK421bi", value: "HK421bi"},
      { text: "HK421bii", value: "HK421bii"},
      { text: "HK421biii", value: "HK421biii"},
      { text: "HK4INCS21b_i", value: "HK4INCS21b_i"},
      { text: "HK4INCS21b_ii", value: "HK4INCS21b_ii"},
      { text: "HK4INCS21b_iii", value: "HK4INCS21b_iii"},
      { text: "HK4INCS21c", value: "HK4INCS21c"},
      { text: "HK4KL", value: "HK4KL"},
      // { text: "dateMula", value: "dateMula"},
      // { text: "dateTamat", value: "dateTamat"},
    ],
  }),
  methods: {
    async exportexcelhk4(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk4serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>